import styled from 'styled-components'
import { mobileBreakpoint, desktopBreakpoint, tabletBreakpoint } from 'react-components'

export const HowItWorksStepContainer = styled.div`
    margin: 1.875rem 0 1.125rem;
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        margin: 0;
    }
`

export const NumberedDotContainer = styled.div`
    display: ${({ theme }) => theme.style.display.flex};
    flex-direction: ${({ theme }) => theme.style.flexDirection.row};
    justify-content: ${({ theme }) => theme.style.justifyContent.center};
    align-items: ${({ theme }) => theme.style.alignItems.center};
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        margin-bottom: 1.875rem;
    }
`

export const HowItWorksStepCardContainer = styled.div`
    margin: 1.875rem 0.46875rem 0;
    min-height: 24rem;
    display: grid;
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        margin: 2.5rem 0.625rem 1.875rem;
        min-height: 21rem;
    }
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        margin: 0 1.625rem;
        height: 83.76%;
        max-width: 21rem;
    }
`

interface DottedLineProps {
    color: string
    marginLeft?: string
    marginRight?: string
}

export const DottedLine = styled.div<DottedLineProps>`
    height: 0;
    border-top: 2px dashed ${({ color }) => color};
    width: 44.2%;
    ${({ marginLeft }) => `margin-left: ${marginLeft}`};
    ${({ marginRight }) => `margin-right: ${marginRight}`};

    @media only screen and (min-width: 500px) and (max-width: ${mobileBreakpoint.max}px) {
        width: 46.4%;
    }
`
